import React, { PropsWithChildren, useContext, useEffect } from 'react'
import { StoresContext } from '@App/contexts'
import { WindowSize } from '@Entities/ui'
import { debounce } from 'lodash'
import { observer } from 'mobx-react'

interface MLCThemeProviderProps {}

const MLCThemeProvider = (props: PropsWithChildren<MLCThemeProviderProps>) => {
    const { uiStore, themeStore } = useContext(StoresContext)
    const { children } = props

    const setWindowSize = () => {
        const sizeData: WindowSize = {
            width: window.innerWidth,
            height: window.innerHeight,
        }
        uiStore.setWindowSize(sizeData)
    }

    useEffect(() => {
        setWindowSize()
        window.addEventListener('resize', debounce(setWindowSize, 200))
    }, [])

    return (
        <div className={`theme--${themeStore.currentTheme}`}>
            <span style={{ display: 'none' }}>{themeStore.currentThemeRenderId}</span>
            {children}
        </div>
    )
}

export default observer(MLCThemeProvider)
